<template>
  <div id="data-pasien">
    <h4 class="text-capitalize mb-3 ">
      data pasien
      <span v-if="idPasien && formData">
        (no. rekam medis: {{ formData.nomor_rekam_medis }})
      </span>
    </h4>
    <b-form>
      <b-container fluid>
        <div class="row justify-content-center">
          <div class="col-sm-12 ">
            <div
              class="card-body"
              style="background: rgb(186 219 251); padding:0.5rem; border-radius:5px; margin-bottom: 10px"
            >
              <b-row>
                <b-col
                  sm="1"
                  class="text-center mt-2"
                  style="padding-right: 5px;"
                >
                  <font-awesome-icon
                    size="3x"
                    style="color: #5565f3; height:40px"
                    icon="clipboard-list"
                  />
                </b-col>
                <b-col
                  sm="11"
                  class="mt-2"
                  style="padding-left: 0px; font-size: 14px; color: #004c8d"
                >
                  <label style="margin-bottom:0.2rem;"
                    ><strong
                      >Anda dapat mengisi kolom yang wajib diisi saja / bertanda
                      * merah, yaitu Nama Lengkap, Jenis Kelamin, Tanggal Lahir,
                      Alamat, dan No. Handphone</strong
                    ></label
                  ><br />
                  <label
                    ><strong
                      >Kolom lain bersifat optional untuk diisi.</strong
                    ></label
                  >
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <b-row>
          <b-col sm="6">
            <b-form-group
              class="text-capitalize"
              style="position: relative"
              :state="getDataError({ rawLabel: 'No. RM Manual' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'No. RM Manual'
                  })
                })
              "
            >
              <label for="">{{
                renderLabel({ label: "No. RM Manual" })
              }}</label>
              <b-form-input
                @keyup="
                  setValue({
                    rawLabel: 'No. RM Manual',
                    $event
                  })
                "
                ref="no_rm_manual"
                :state="getDataError({ rawLabel: 'No. RM Manual' })"
                :disabled="disabledForm()"
                :value="getValue('No. RM Manual')"
                :maxlength="20"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6"></b-col>
          <b-col sm="6">
            <b-form-group
              class="text-capitalize"
              style="position: relative"
              :state="getDataError({ rawLabel: 'nama lengkap' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'nama lengkap'
                  })
                })
              "
            >
              <label for="">{{ renderLabel({ label: "nama lengkap" }) }}</label>
              <label for="" style="color:red"> *</label>
              <b-form-input
                @keyup="
                  setValue({
                    rawLabel: 'nama lengkap',
                    $event
                  })
                "
                ref="nama_lengkap"
                :state="getDataError({ rawLabel: 'nama lengkap' })"
                :disabled="disabledForm()"
                :value="getValue('nama lengkap')"
                :maxlength="60"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="renderLabel({ label: 'status perkawinan' })"
              class="text-capitalize"
              style="position: relative"
            >
              <vue-select
                :options="['Belum Kawin', 'Kawin', 'Cerai Hidup', 'Cerai Mati']"
                @input="
                  setValue({
                    rawLabel: 'status perkawinan',
                    $event
                  })
                "
                :disabled="disabledForm()"
                :value="getValue('status perkawinan')"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="2">
            <b-form-group
              class="text-capitalize"
              style="position: relative;"
              :state="getDataError({ rawLabel: 'jenis identitas' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'jenis identitas'
                  })
                })
              "
            >
              <label>Jenis Identitas</label>
              <template
                v-if="this.formData['jenis_identitas'] || this.formData['nik']"
              >
                <label style="color:red"> *</label>
              </template>
              <vue-select
                :options="['KTP', 'SIM', 'Paspor']"
                @input="
                  setValue({
                    rawLabel: 'jenis identitas',
                    $event
                  })
                "
                :disabled="disabledForm()"
                :value="getValue('jenis identitas')"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="4">
            <b-form-group
              class="text-capitalize"
              style="position: relative"
              :state="getDataError({ rawLabel: 'nik' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'nik'
                  })
                })
              "
            >
              <label>No. identitas</label>
              <template
                v-if="this.formData['jenis_identitas'] || this.formData['nik']"
              >
                <label for="" style="color:red"> *</label>
              </template>
              <template
                v-if="
                  this.formData['jenis_identitas'] !== '' &&
                    this.formData['jenis_identitas'] !== null
                "
              >
                <b-form-input
                  v-if="this.formData['jenis_identitas'] !== 'Paspor'"
                  @keypress="
                    onKeyInputNumber({
                      rawLabel: 'nik',
                      $event
                    })
                  "
                  @keyup="
                    setValue({
                      rawLabel: 'nik',
                      $event
                    });
                    checkNIK();
                  "
                  :disabled="disabledForm()"
                  :state="getDataError({ rawLabel: 'nik' })"
                  :value="getValue('nik')"
                  :maxlength="25"
                  required
                />
                <b-form-input
                  v-else
                  @keyup="
                    setValue({
                      rawLabel: 'nik',
                      $event
                    });
                    checkNIK();
                  "
                  :disabled="disabledForm()"
                  :state="getDataError({ rawLabel: 'nik' })"
                  :value="getValue('nik')"
                  :maxlength="25"
                  required
                />
                <template
                  v-if="
                    this.formBasicData[3].error == true &&
                      this.formData.nik !== ''
                  "
                >
                  <label style="color:red">No. Identitas telah terdaftar</label>
                </template>
              </template>
              <template v-else-if="this.formData['jenis_identitas'] == null">
                <b-form-input
                  v-if="this.formData['jenis_identitas'] !== 'Paspor'"
                  @keypress="
                    onKeyInputNumber({
                      rawLabel: 'nik',
                      $event
                    })
                  "
                  @keyup="
                    setValue({
                      rawLabel: 'nik',
                      $event
                    });
                    checkNIK();
                  "
                  :disabled="disabledForm()"
                  :state="getDataError({ rawLabel: 'nik' })"
                  :value="getValue('nik')"
                  :maxlength="25"
                />
                <b-form-input
                  v-else
                  @keypress="checkInput"
                  @keyup="
                    setValue({
                      rawLabel: 'nik',
                      $event
                    });
                    checkNIK();
                  "
                  :disabled="disabledForm()"
                  :state="getDataError({ rawLabel: 'nik' })"
                  :value="getValue('nik')"
                  :maxlength="25"
                />
                <template
                  v-if="
                    this.formBasicData[3].error == true &&
                      this.formData.nik !== ''
                  "
                >
                  <label style="color:red">No. Identitas telah terdaftar</label>
                </template>
              </template>
              <template v-else>
                <b-form-input
                  v-if="this.formData['jenis_identitas'] !== 'Paspor'"
                  id="fck-shit"
                  @keypress="
                    checkInput({
                      rawLabel: 'nik',
                      $event
                    })
                  "
                  @keyup="
                    setValue({
                      rawLabel: 'nik',
                      $event
                    });
                    checkNIK();
                  "
                  :disabled="disabledForm()"
                  :state="getDataError({ rawLabel: 'nik' })"
                  :value="getValue('nik')"
                  :maxlength="25"
                />
                <b-form-input
                  v-else
                  @keyup="
                    setValue({
                      rawLabel: 'nik',
                      $event
                    });
                    checkNIK();
                  "
                  :disabled="disabledForm()"
                  :state="getDataError({ rawLabel: 'nik' })"
                  :value="getValue('nik')"
                  :maxlength="25"
                />
                <template
                  v-if="
                    this.formBasicData[3].error == true &&
                      this.formData.nik !== ''
                  "
                >
                  <label style="color:red">No. Identitas telah terdaftar</label>
                </template>
              </template>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              class="text-capitalize"
              style="position: relative"
              :state="getDataError({ rawLabel: 'no. handphone' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'no. handphone'
                  })
                })
              "
            >
              <label for="">{{
                renderLabel({ label: "no. handphone" })
              }}</label>
              <label for="" style="color:red"> *</label>
              <b-form-input
                @keypress="
                  onKeyInputNumber({
                    rawLabel: 'no. handphone',
                    $event
                  })
                "
                @keyup="
                  setValue({
                    rawLabel: 'no. handphone',
                    $event
                  })
                "
                ref="no_handphone"
                :state="getDataError({ rawLabel: 'no. handphone' })"
                :disabled="disabledForm()"
                :value="getValue('no. handphone')"
                :maxlength="15"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="2">
            <b-form-group
              :state="getDataError({ rawLabel: 'jenis kelamin' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'jenis kelamin'
                  })
                })
              "
            >
              <label for="">{{
                renderLabel({ label: "Jenis kelamin" })
              }}</label>
              <label for="" style="color:red"> *</label>
              <b-form-radio-group
                stacked
                @change="
                  setValue({
                    rawLabel: 'jenis kelamin',
                    $event
                  })
                "
                class="text-capitalize"
                :options="[
                  { text: 'laki-laki', value: 1 },
                  { text: 'perempuan', value: 0 }
                ]"
                :disabled="disabledForm()"
                :checked="getValue('jenis kelamin')"
              >
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="4">
            <b-form-group
              class="text-capitalize"
              style="position: relative"
              :state="getDataError({ rawLabel: 'tanggal lahir' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'tanggal lahir'
                  })
                })
              "
            >
              <label for="">{{
                renderLabel({ label: "tanggal lahir" })
              }}</label>
              <label for="" style="color:red"> *</label>
              <!-- </b-input-group> -->

              <date-picker
                v-model="formData.tanggal_lahir"
                :disabled-date="notAfterToday"
                type="date"
                format="DD-MM-YYYY"
                value-type="YYYY-MM-DD"
                placeholder="DD-MM-YYYY"
              >
              </date-picker>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="renderLabel({ label: 'email' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'email'
                  })
                })
              "
              :state="getDataError({ rawLabel: 'email' })"
              class="text-capitalize"
              style="position: relative;"
            >
              <b-form-input
                @keyup="
                  setValue({
                    rawLabel: 'email',
                    $event
                  })
                "
                :disabled="disabledForm()"
                :value="getValue('email')"
                :maxlength="30"
                :invalid-feedback="
                  renderInvalidFeedback({
                    validationDesc: blindlyGetData({
                      rawLabel: 'email'
                    })
                  })
                "
              />
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="4" offset-lg="2">
            <b-form-group
              :label="renderLabel({ label: 'gol. darah' })"
              class="text-capitalize"
              style="position: relative;"
              :state="getDataError({ rawLabel: 'gol. darah' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'gol. darah'
                  })
                })
              "
            >
              <vue-select
                :options="['A', 'B', 'AB', 'O']"
                @input="
                  setValue({
                    rawLabel: 'gol. darah',
                    $event
                  })
                "
                :disabled="disabledForm()"
                :value="getValue('gol. darah')"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="renderLabel({ label: 'nama penanggung jawab' })"
              class="text-capitalize"
              style="position: relative"
              :state="getDataError({ rawLabel: 'nama penanggung jawab' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'nama penanggung jawab'
                  })
                })
              "
            >
              <b-form-input
                @keyup="
                  setValue({
                    rawLabel: 'nama penanggung jawab',
                    $event
                  })
                "
                :disabled="disabledForm()"
                :value="getValue('nama penanggung jawab')"
                :maxlength="30"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              class="text-capitalize"
              style="position: relative"
              :state="getDataError({ rawLabel: 'alamat rumah' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'alamat rumah'
                  })
                })
              "
            >
              <label for="">{{ renderLabel({ label: "alamat rumah" }) }}</label>
              <label for="" style="color:red"> *</label>
              <b-form-input
                @keyup="
                  setValue({
                    rawLabel: 'alamat rumah',
                    $event
                  })
                "
                ref="alamat"
                :state="getDataError({ rawLabel: 'alamat rumah' })"
                :disabled="disabledForm()"
                :value="getValue('alamat rumah')"
                :maxlength="100"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="renderLabel({ label: 'no. hp penanggung jawab' })"
              class="text-capitalize"
              style="position: relative"
              :state="getDataError({ rawLabel: 'no. hp penanggung jawab' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'no. hp penanggung jawab'
                  })
                })
              "
            >
              <b-form-input
                @keypress="
                  onKeyInputNumber({
                    rawLabel: 'no. hp penanggung jawab',
                    $event
                  })
                "
                @keyup="
                  setValue({
                    rawLabel: 'no. hp penanggung jawab',
                    $event
                  })
                "
                :disabled="disabledForm()"
                :value="getValue('no. hp penanggung jawab')"
                :maxlength="15"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              lass="text-capitalize"
              style="position: relative"
              :state="getDataError({ rawLabel: 'provinsi' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'provinsi'
                  })
                })
              "
            >
              <label>Provinsi</label>
              <template v-if="tempat.provinsi">
                <label style="color:red"> *</label>
              </template>
              <vue-select
                :options="provinces"
                @input="getCity"
                :disabled="disabledForm()"
                v-model="tempat.provinsi"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="renderLabel({ label: 'hubungan dengan pasien' })"
              class="text-capitalize"
              style="position: relative"
            >
              <vue-select
                :options="[
                  'Suami/Istri',
                  'Orangtua',
                  'Kakak/Adik',
                  'Anak',
                  'Lainnya'
                ]"
                @input="
                  setValue({
                    rawLabel: 'hubungan pasien',
                    $event
                  })
                "
                :disabled="disabledForm()"
                :value="getValue('hubungan pasien')"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              class="text-capitalize"
              style="position: relative"
              :state="getDataError({ rawLabel: 'kota' })"
              :invalid-feedback="
                renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'kota'
                  })
                })
              "
            >
              <label>Kota</label>
              <template v-if="tempat.provinsi">
                <label style="color:red"> *</label>
              </template>
              <vue-select
                :options="cities"
                v-model="tempat.kota"
                @input="setDataTempat"
                :disabled="disabledForm()"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <template v-if="formType !== 'detail' && formType !== 'edit'">
              <b-form-group class="text-capitalize" style="position: relative">
                <p class="mb-1 flex-grow-1">
                  Masukan Pasien ke Antrean?
                  <toggle-button
                    v-model="isAntrean"
                    :labels="{ checked: 'Ya', unchecked: 'Tidak' }"
                    :width="65"
                    :color="{
                      checked: '#3c44b1',
                      unchecked: '#f83245',
                      disabled: '#CCCCCC'
                    }"
                    style="float:right"
                  />
                </p>
              </b-form-group>
            </template>
          </b-col>
          <b-col sm="6">
            <b-form-group
              class=" p-3"
              style="position: relative; background-color: #efefef"
            >
              <strong class="text-uppercase">informasi Pasien</strong>
              <br />
              <div class="row">
                <div class="col">
                  <label class="mt-2">Tinggi Badan (cm)</label>
                  <b-form-input
                    :maxlength="6"
                    @keyup="
                      setValue({
                        rawLabel: 'tinggi badan',
                        $event
                      })
                    "
                    @keydown.native="
                      onKeyInputNumberSpecial({
                        rawLabel: 'tinggi badan',
                        $event
                      })
                    "
                    :disabled="disabledForm()"
                    :value="
                      getValue('tinggi badan')
                        ? getValue('tinggi badan')
                            .toString()
                        : null
                    "
                  />
                </div>
                <div class="col">
                  <label class="mt-2">Berat Badan (kg)</label>
                  <b-form-input
                    :maxlength="5"
                    @keydown.native="
                      onKeyInputNumberSpecial({
                        rawLabel: 'berat badan',
                        $event
                      })
                    "
                    @keyup="
                      setValue({
                        rawLabel: 'berat badan',
                        $event
                      })
                    "
                    :disabled="disabledForm()"
                    :value="
                      getValue('berat badan')
                        ? getValue('berat badan')
                            .toString()
                        : null
                    "
                  />
                </div>
              </div>
              <label class="text-capitalize mt-2"
                >alergi & kondisi khusus</label
              >
              <b-form-textarea
                id="textarea"
                size="lg"
                :maxlength="50"
                @keyup="
                  setValue({
                    rawLabel: 'alergi kondisi khusus',
                    $event
                  })
                "
                :disabled="disabledForm()"
                :value="getValue('alergi kondisi khusus')"
              ></b-form-textarea>
              <label class="text-capitalize mt-2">Keterangan Lain</label>
              <b-form-textarea
                id="textarea1"
                size="lg"
                :maxlength="30"
                @keyup="
                  setValue({
                    rawLabel: 'keterangan lain',
                    $event
                  })
                "
                :disabled="disabledForm()"
                :value="getValue('keterangan lain')"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col sm="6"> </b-col>
          <b-col sm="6"> </b-col>
          <b-col sm="6">
            <template v-if="formType !== 'detail'">
              <b-button
                class="ml-3 text-uppercase"
                variant="primary"
                style="font-size:17.5px;float:right "
                @click="submitForm"
                >simpan
              </b-button>
              <b-button
                :to="{ name: 'pasien-list' }"
                class="text-uppercase"
                :variant="btnVariant()"
                style="font-size:17.5px; float:right"
                >{{ btnText() }}</b-button
              >
            </template>
            <template v-else>
              <b-button
                :to="{ name: 'pasien-list' }"
                class="text-uppercase"
                :variant="btnVariant()"
                style="font-size:17.5px; float:right"
                >{{ btnText() }}</b-button
              >
              <b-button
                class="mr-4 text-uppercase float-right"
                variant="success"
                style="font-size:17.5px;"
                @click="
                  $router.push({
                    name: 'pasien-edit',
                    params: { idPasien }
                  })
                "
                >edit</b-button
              >
            </template>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
  </div>
</template>

<script>
import Vue from "vue";

import axios from "axios";
import { mapGetters } from "vuex";
import startCase from "lodash/startCase";
import ImageUploader from "vue-image-upload-resize";
import { ToggleButton } from "vue-js-toggle-button";
Vue.use(ImageUploader);
import {
  required,
  minLength,
  numeric,
  email
} from "vuelidate/lib/validators";
import "vue-datetime/dist/vue-datetime.css";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import moment from "moment";
moment.locale("id");
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCamera,
  faCaretDown,
  faCalendar,
  faClipboardList
} from "@fortawesome/free-solid-svg-icons";
library.add(faClipboardList, faCamera, faCaretDown, faCalendar);

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

const tmp = [
  {
    label: "No. RM Manual",
    alias: "nomor_rekam_medis_manual",
    error: false,
    validations: {}
  },
  {
    label: "nama lengkap",
    alias: "nama",
    validations: {
      required
    }
  },
  {
    label: "no. handphone",
    alias: "nomor_hp",
    validations: {
      required,
      numeric,
      minLength: minLength(10)
    }
  },
  {
    label: "nik",
    alias: "nik",
    error: false,
    validations: {}
  },
  {
    label: "email",
    alias: "email",
    error: false,
    validations: {
      email
    }
  },
  {
    label: "tanggal lahir",
    alias: "tanggal_lahir",
    validations: {
      required
    }
  },
  {
    label: "jenis kelamin",
    alias: "jenis_kelamin",
    validations: {
      required
    }
  },
  {
    label: "gol. darah",
    alias: "golongan_darah",
    error: false,
    validations: {}
  },
  {
    label: "nama penanggung jawab",
    alias: "nama_penanggung_jawab",
    error: false,
    validations: {}
  },
  {
    label: "no. hp penanggung jawab",
    alias: "nomor_hp_penanggung_jawab",
    error: false,
    validations: {
    }
  },
  {
    label: "hubungan pasien",
    alias: "hubungan_pasien",
    error: false,
    validations: {}
  },
  {
    label: "alamat rumah",
    alias: "alamat_rumah",
    validations: {
      required
    }
  },
  {
    label: "status perkawinan",
    alias: "status_perkawinan",
    error: false,
    validations: {}
  },
  {
    label: "jenis identitas",
    alias: "jenis_identitas",
    error: false,
    validations: {}
  },
  {
    label: "nomor rekam medis",
    alias: "nomor_rekam_medis",
    error: false,
    validations: {}
  },
  {
    label: "provinsi",
    alias: "provinsi",
    error: false,
    validations: {}
  },
  {
    label: "kota",
    alias: "kota",
    error: false,
    validations: {}
  },
  {
    label: "tinggi badan",
    alias: "tinggi_badan",
    error: false,
    validations: {}
  },
  {
    label: "berat badan",
    alias: "berat_badan",
    error: false,
    validations: {}
  },
  {
    label: "alergi kondisi khusus",
    alias: "alergi_kondisi_khusus",
    error: false,
    validations: {}
  },
  {
    label: "keterangan lain",
    alias: "keterangan_lain",
    error: false,
    validations: {}
  }
];
moment.locale("id");
export default {
  components: {
    "vue-select": () => import("@/components/VueSelectClearable.vue"),
    "date-picker": DatePicker,
    "toggle-button": ToggleButton
  },
  props: {
    formType: {
      default: "add",
      type: String
    },
    idPasien: {
      type: [String, Number]
    }
  },
  data: () => ({
    beingSubmit: false,
    formBasicData: null,
    formData: null,
    options: ["foo", "bar", "baz"],
    selected: null,
    hasImage: false,
    heightFoto: "",
    image: null,
    isAntrean: false,
    selectTempat: null,
    checkValueNik: null,
    provinces: [],
    cities: [],
    tempat: {
      provinsi: null,
      kota: null
    }
  }),
  watch: {
    "formData.tanggal_lahir": function(val) {
      if (val != "") {
        this.formBasicData[5].error = false;
      }
    },
    tempat: {
      handler: function(val) {
        // console.log(val)
      },
      deep: true
    },
    "tempat.provinsi": {
      handler: function(newVal, oldVal) {
        if (newVal === oldVal) {
          const { provinsi_name: pnl } = newVal;
          const { provinsi_name: pnb } = oldVal;
          if (pnl.toLowerCase() !== pnb.toLowerCase()) {
            this.provinsi.kota = null;
          }
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      getRolesName: "getRolesName"
    }),
    maximumDatetime() {
      return moment().format("YYYY-MM-DD");
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: startCase("keluar"),
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  validations() {
    return {
      formData: {
        ...tmp.reduce((obj, item) => {
          obj[item.label.split(" ").join("_")] = item.validations;
          return obj;
        }, {})
      }
    };
  },
  async mounted() {
    this.formBasicData = this.setFormBasicData();
    this.formData = this.setFormData();
    this.getProvince();
    this.getPasienData();
    this.isAntrean = localStorage.getItem('is_antrean') ? true : false
  },
  methods: {
    notAfterToday(date) {
      return date > new Date(new Date().setHours(0, 0, 0, 0));
    },
    triggerDob() {
      const x = this.$refs.dob;
      const {
        $el: { firstElementChild }
      } = x;
      firstElementChild && firstElementChild.click();
    },
    getProvince() {
      axios
        .get(`${this.url_api}/province`)
        .then(response => {
          // handle success
          this.provinces = response.data.data.provinsi.map(val => ({
            ...val,
            label: `${val.provinsi_nama}`
          }));
        })
        .catch(error => {
          // handle error
          // console.log(error);
        });
    },
    checkNIK() {
      clearTimeout(this.timeVerifyNIK);
      this.timeVerifyNIK = setTimeout(async () => {
        const res = await axios.get(
          `${this.url_api}/identity/verify?jenis_pengenal=${this.formData["jenis_identitas"]}&nik=${this.formData["nik"]}`
        );
        if (res.data.status == false) {
          this.formBasicData[3].error = true;
        } else {
          this.formBasicData[3].error = false;
          console.log("NIk BERHASIL");
        }
      }, 550);
    },
    async getCity() {
      this.tempat.kota = null;
      try {
        var val;
        if (this.tempat.provinsi == "" || this.tempat.provinsi == null) {
          val = "";
        } else {
          val = this.tempat.provinsi.id;
          const res = await axios.get(
            `${this.url_api}/getcitybyprovince/${val}`
          );
          // handle success
          this.cities = res.data.data.kota.map(val => ({
            ...val,
            label: `${val.nama}`
          }));
        }
        if (this.$router.currentRoute.params.idPasien) {
          if (this.formType == "edit") {
            if (this.tempat.kota.provinsi_id !== this.tempat.provinsi.id) {
              this.tempat.kota = null;
            }
          }
        } else if (this.cities[0].provinsi_id !== this.tempat.provinsi) {
          this.tempat.kota = null;
        }
      } catch (error) {
        console.error(error);
      }
    },
    setDataTempat() {
      this.formData["provinsi"] = this.tempat.provinsi.id;
      this.formData["kota"] = this.tempat.kota.id;
    },
    startCase: startCase,
    stupidOcrHelper({ alias, val }) {
      const mapGender = val => {
        const x = 1;
        return /empu|wan/gi.test(val) ? x * 0 : x;
      };

      switch (alias.toLowerCase()) {
        case "gender":
          return mapGender(val);

        default:
          return val;
      }
    },
    assignValuePasien(data) {
      if (data) {
        Object.keys(data).map(item => {
          const y = this.formBasicData.find(x => x.alias === item);
          if (y) {
            const { stupidOcrHelper } = this;
            Vue.set(
              this.formData,
              y.label,
              stupidOcrHelper({
                alias: y.alias,
                val: (() => {
                  return (
                    (typeof data[item] === "string" && data[item].trim()) ||
                    data[item]
                  );
                })()
              })
            );
          }
        });
      }
      console.log('INI DATA', this.formData)
    },
    btnText() {
      switch (this.formType) {
        case "detail":
          return "tutup";

        case "edit":
          return "batal";

        default:
          return "keluar";
      }
    },
    btnVariant() {
      switch (this.formType) {
        case "detail":
          return "primary";

        default:
          return "danger";
      }
    },
    disabledForm() {
      return this.formType === "detail";
    },
    tanggalLahirSelected($event) {
      if (!$event) return;
      this.setValue({
        rawLabel: "tanggal lahir",
        $event: moment($event).format("YYYY-MM-DD")
      });
    },
    async getPasienData() {
      this.idPasien = this.$router.currentRoute.params.idPasien;
      try {
        const res = await axios.get(
          `${this.url_api}/pasien/${this.idPasien}`
        );
        const { status, data } = res.data;
        if (status) {
          const { assignValuePasien } = this;
          var prev = data.tanggal_lahir;
          
          assignValuePasien(data);
          this.tempat.provinsi = {
            ...data.provinsi,
            label: data.provinsi.provinsi_nama
          };
          this.getCity();
          this.tempat.kota = {
            ...data.kota,
            label: data.kota.nama
          };
        }
      } catch (err) {
        console.log(err);
        // alert(err)
      }
    },
    whitelistValidation() {
      return this.setFormBasicData()
        .filter(item => item.validations && !item.validations.required)
        .map(item => item.rawLabel);
    },
    setFormData() {
      return this.setFormBasicData().reduce((arr, val) => {
        let key = val.label.split(" ").join("_");
        arr[key] = "";
        return arr;
      }, {});
    },
    setFormBasicData() {
      return tmp.map((item, index) => ({
        ...item,
        label: item.label.split(" ").join("_"),
        tmpId: index,
        error: null,
        rawLabel: item.label
      }));
    },
    checkInput({ rawLabel, $event }) {
      const { key } = $event;
      var evt = $event;
      evt = evt ? evt : window.event;
      if (/[^a-zA-Z0-9\-\.]/.test(key)) {
        evt.preventDefault();
      } else {
        return;
      }
    },
    onKeyInputNumberSpecial({ rawLabel, $event }) {
      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      console.log('charCOde', charCode)
      if (
        charCode == 37 ||
        charCode == 38 ||
        charCode == 39 ||
        charCode == 40 ||
        charCode == 8 ||
        charCode == 46 ||
        charCode == 9
      ) {
        return;
      }

      if (!evt.key.match(/[0-9.,]/)) {
        evt.preventDefault();
      }
    },
    onKeyInputNumber({ rawLabel, $event }) {
      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        void this.setValue({
          rawLabel,
          $event
        });
      }
    },
    setValue({ rawLabel, $event = null } = {}) {
      let value = $event;
      const label = rawLabel.split(" ").join("_");
      if (typeof $event === "object") {
        if ($event) {
          const {
            target: { value }
          } = $event;
          this.formData[label] = value;
        } else {
          this.formData[label] = null;
        }
      } else {
        this.formData[label] = value;
      }
      this.triggerValidation({
        label,
        $v: this.$v,
        $vm: this,
        rawLabel
      });
    },
    submitForm() {
      if (!this.formData["jenis_identitas"] && !this.formData["nik"]) {
      } else if (this.formData["jenis_identitas"] && this.formData["nik"]) {
      } else if (
        this.formData["jenis_identitas"] !== null &&
        !this.formData["nik"]
      ) {
        return this.$swal({
          text: `Nomor Identitas harus diisi !`,
          type: "error",
          showCancelButton: false,
          confirmButtonText: startCase("ya")
        }).then(res => {
          const { value } = res;
          if (value) {
            return;
          }
        });
      } else if (
        !this.formData["jenis_identitas"] &&
        this.formData["nik"] !== null
      ) {
        return this.$swal({
          text: `Jenis Identitas harus diisi !`,
          type: "error",
          showCancelButton: false,
          confirmButtonText: startCase("ya")
        }).then(res => {
          const { value } = res;
          if (value) {
            return;
          }
        });
      }

      const { formBasicData } = this;
      formBasicData.map(item => {
        this.triggerValidation({
          label: item.label,
          $v: this.$v,
          $vm: this,
          rawLabel: item.rawLabel
        });
      });

      if (formBasicData.every(item => item.error !== null && !item.error)) {
        if (this.formData.provinsi) {
          this.formData.provinsi =
            this.tempat.provinsi && this.tempat.provinsi.id
              ? this.tempat.provinsi.id
              : null;
          this.formData.kota =
            this.tempat.kota && this.tempat.kota.id
              ? this.tempat.kota.id
              : null;
        }

        if (this.tempat.provinsi && !this.tempat.kota) {
          return this.$swal({
            text: `Kota Harus Diisi !`,
            type: "error",
            showCancelButton: false,
            confirmButtonText: startCase("ya")
          });
        }

        this.$emit("submitForm", {
          ...this.formData,
          tanggal_lahir: moment(this.formData.tanggal_lahir).format(
            "YYYY-MM-DD"
          ),
          addToAntrean: this.isAntrean
        });
      } else {
        if (this.formBasicData[1].error) {
          this.$refs.nama_lengkap.focus();
        } else if (this.formBasicData[2].error) {
          this.$refs.no_handphone.focus();
        } else if (this.formBasicData[11].error) {
          this.$refs.alamat.focus();
        } else if (this.formBasicData[5].error) {
          this.$refs.nama_lengkap.focus();
          window.scrollTo({
            top: 260,
            behavior: "smooth"
          });
          this.$refs.nama_lengkap.blur();
        } else if (this.formBasicData[3].error) {
          this.$refs.nama_lengkap.focus();
          window.scrollTo({
            top: 260,
            behavior: "smooth"
          });
          this.$refs.nama_lengkap.blur();
        }

        this.$swal({
          text: `Silakan lengkapi kolom yang harus diisi!`,
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "OK",
          scrollbarPadding: false
        });
      }
    }
  }
};
</script>

<style>
#fileInput {
  display: none;
  position: absolute;
}

.text-foto {
  width: 100%;
  background-color: #f2f3f4;
  padding: 15px;
  border-radius: 15px;
  margin-top: 30px;
  z-index: 999;
}

.text-foto:hover {
  background-color: #d5d8dc;
}

.overlay-upload {
  top: 0px;
  left: 0px;
  background-image: linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(0, 0, 0, 0.5) 83%,
    rgba(0, 0, 0, 0.8)
  );
  width: 100%;
  height: auto;
  position: absolute;
}
</style>

<style lang="scss">
.foto-upload {
  & .text-foto {
    cursor: pointer;
  }
}
.mx-datepicker {
  width: 100%;
}

.mx-input {
  height: 40px !important;
  border-radius: 5px;
}
</style>
